export const API_GET_APPOINTMENTS_MESSAGES = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_SAVE_APPOINTMENT_MESSAGES = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_SAVE_TICKET_MESSAGES = {
  2: {
    responseCode: '02',
    type: 'warning',
    message: 'La fecha de cita es diferente al día de hoy',
  },
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_REASONS_LIST_MESSAGES = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_ATTENTION_QUEUE_LIST_MESSAGES = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_PRIORITY_LIST_MESSAGES = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};
export const API_BOXES_LIST_MESSAGES = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};
export const API_HEADQUARTERS_LIST_MESSAGES = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_REGISTER_BOX_MESSAGES = {
  2: {
    responseCode: '02',
    type: 'warning',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_TYPIFICATION_LIST_MESSAGES = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};

export const API_REGISTER_NON_CLIENT = {
  99: {
    responseCode: '99',
    type: 'error',
    message: 'En estos momentos estamos teniendo problemas con el servidor.',
  },
};
